<template>
  <section
    class="flex flex-col items-center justify-center w-full h-[90vh] px-4 bg-transparent overflow-auto"
  >
    <!-- Profile Section -->
    <div class="profile-section flex flex-col items-center text-center">
      <img
        src="@/assets/img/mark.jpg"
        alt="MARCK LESTER L. NAVALES"
        class="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full border-4 border-gray-300 mb-4 object-cover"
      />
      <h1
        class="text-lg sm:text-lg md:text-xl lg:text-2xl font-bold text-white"
      >
        MARCK LESTER L. NAVALES
      </h1>
      <h2 class="text-lg text-white mb-8">Accountant III</h2>
    </div>

    <!-- Feedback Content -->
    <div
      class="flex flex-col-reverse lg:flex-row items-center justify-center gap-8 md:gap-10 w-full max-w-6xl"
    >
      <!-- Text -->
      <div class="flex-1 flex items-center justify-center">
        <p
          class="text-white text-justify text-[15px] sm:text-[16px] md:text-[17px] font-light leading-relaxed"
        >
          The Unified Digital Ecosystem of Davao del Norte State College has
          changed the way I see and experience work, service, and education.
          It’s not just a collection of systems — it’s a living symbol of how
          far we’ve come as an institution. I have witnessed the shift from
          manual processes and piles of paperwork to a seamless digital
          environment where things are faster, clearer, and more connected. This
          transformation didn’t just make our tasks easier; it brought a sense
          of unity and shared purpose that made us realize we are part of
          something bigger — an institution that dares to innovate and lead.
        </p>
      </div>

      <!-- Image -->
      <div class="flex-1 flex justify-center">
        <img
          src="@/assets/img/mark-1.jpg"
          alt="MARCK LESTER L. NAVALES"
          class="w-full md:w-[500px] md:h-[390px] lg:h-[320px] h-full rounded-2xl border-2 border-gray-300 object-cover shadow-lg"
        />
      </div>
    </div>

    <!-- Additional Paragraphs -->
    <div class="flex flex-col space-y-4 mt-2 md:mt-4 lg:mt-4 max-w-4xl">
      <p
        class="text-justify text-[15px] sm:text-[16px] md:text-[17px] text-white font-light leading-relaxed"
      >
        The Unified Digital Ecosystem of Davao del Norte State College has
        changed the way I see and experience work, service, and education. It’s
        not just a collection of systems — it’s a living symbol of how far we’ve
        come as an institution. I have witnessed the shift from manual processes
        and piles of paperwork to a seamless digital environment where things
        are faster, clearer, and more connected. This transformation didn’t just
        make our tasks easier; it brought a sense of unity and shared purpose
        that made us realize we are part of something bigger — an institution
        that dares to innovate and lead.
      </p>
      <p
        class="text-justify text-[15px] sm:text-[16px] md:text-[17px] text-white font-light leading-relaxed"
      >
        For me, this digital transformation is deeply human. Behind every
        upgrade and system enhancement are people — colleagues who adapted,
        learned, and persevered. It has taught us to trust technology, to see it
        not as a threat but as a partner in fulfilling our mission. Through the
        Unified Digital Ecosystem, I’ve seen how collaboration has become
        smoother, how decisions are made more wisely, and how our service to
        students and stakeholders has become more responsive and transparent. It
        has reshaped not only how we work but also how we think as one community
        moving forward together.
      </p>
    </div>

    <!-- Close Button -->
    <button
      @click="$emit('close')"
      class="mt-10 px-8 py-3 bg-white/20 backdrop-blur-md text-white font-semibold rounded-full border border-white/40 shadow-lg hover:bg-red-600 hover:text-white hover:border-red-600 transition duration-300 ease-in-out"
    >
      Close
    </button>
  </section>
</template>

<script>
export default {
  name: "IanFeedbackContent",
};
</script>

<style scoped>
/* ✅ Custom responsive spacing for the profile section */
.profile-section {
  margin-top: 80rem; /* default for mobile */
}

@media (min-width: 640px) {
  /* sm screens (small tablets, large phones) */
  .profile-section {
    margin-top: 8rem;
  }
}

@media (min-width: 768px) {
  /* md screens (tablets) */
  .profile-section {
    margin-top: 48rem;
  }
}

@media (min-width: 1024px) {
  /* lg screens (laptops/desktops) */
  .profile-section {
    margin-top: 60rem;
  }
}

@media (min-width: 1280px) {
  /* xl screens (large desktops) */
  .profile-section {
    margin-top: 10rem;
  }
}
/* Smooth scrollbar for overflow sections */
section::-webkit-scrollbar {
  width: 8px;
}
section::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 10px;
}
</style>
